import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { useQuery } from "urql";
import { DataAccessResult } from "@acto/taskpane/core/data-access/types";
import { isFetchingResult } from "@acto/taskpane/core/data-access/isFetchingResult";
import { MeetingPrepCardHide } from "@acto/taskpane/core/domain";

const HiddenMeetingPrepCardsQuery = graphql(`
  query GetHiddenMeetingPrepCards($clientId: ID!, $prepSessionId: String!) {
    hiddenMeetingPrepCards(clientId: $clientId, prepSessionId: $prepSessionId) {
      id
      __typename
      clientId
      prepSessionId
      cardKey
      cardType
      reason
    }
  }
`);

export function useHiddenMeetingPrepCards(
  clientId?: string,
  prepSessionId?: string | null,
): DataAccessResult<MeetingPrepCardHide> {
  const [result] = useQuery({
    query: HiddenMeetingPrepCardsQuery,
    variables: { clientId: clientId ?? "", prepSessionId: prepSessionId ?? "" },
    pause: !clientId || !prepSessionId,
  });

  const requested = result.operation?.variables;
  const matchesRequest = requested?.clientId === clientId && requested?.prepSessionId === prepSessionId;
  const data = matchesRequest ? result.data : undefined;
  const error = matchesRequest ? result.error : undefined;
  const isFetching = isFetchingResult(result);
  const isPending = !data && isFetching;

  const hides = useMemo(() => data?.hiddenMeetingPrepCards.map(MeetingPrepCardHide.fromGraphql), [data]);

  return {
    data: hides,
    isFetching,
    isPending,
    error,
  };
}
